const version = "3.11.1";
const publishDates = {
  major: "2024-09-13T14:36:29.063Z",
  minor: "2025-03-20T14:45:59.625Z",
  patch: "2025-04-03T10:34:39.217Z"
};
export {
  publishDates,
  version
};
//# sourceMappingURL=version.mjs.map
